import { Injectable, Injector } from '@angular/core';
import { PlatformApiWpService } from './platform-apiwp.service';
import { BehaviorSubject, Observable, catchError, first, map, take } from 'rxjs';
import { Product } from '@mare-common/ngx-delfi-components/lib/products-list/product.interface';
import { PlatformApiWPublicService } from './platform-apiwp-public.service';
import { DoubleService } from './double-service';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { TokenService } from './token.service';
export interface ProductsRequestParams{
  serviceList?: boolean,
  ids?: string, // comma separated list of ids
  skus?: string, // comma separated list of skus
  slugs?: string, // comma separated list of slugs
  cat?: string, // comma separated list of slugs of wp taxonomy 'product_cat' 
  tags?: string, // comma separated list of slugs of wp taxonomy 'product_tag'
  getVariations?: boolean,
  purchasedOnly?: boolean // if true, only returns products that have been purchased
}
export interface ProductsPurchasedRequest{
  ids: number[],
  names: string[]
}
@Injectable({
  providedIn: 'root'
})
export class ProductService extends DoubleService{
  

  allProducts!: Array<any>;
  hasVariations!: boolean;
  allProducts$: BehaviorSubject<Array<Product>> = new BehaviorSubject<Array<Product>>([]);
  allOmniaInterestsProducts!: Array<any>;
  allOmniaInterestsProducts$: BehaviorSubject<Array<string>> = new BehaviorSubject<Array<string>>([]);

  allPurchasedProducts!: Array<ProductsPurchasedRequest>;
  allPurchasedProducts$: BehaviorSubject<Array<ProductsPurchasedRequest>> = new BehaviorSubject<Array<ProductsPurchasedRequest>>([]);
  pendingRequests: any;
  oldPendingRequests: any;

  // protected platformApiWpService!: PlatformApiWPublicService | PlatformApiWpService;

  constructor(
    // private platformApiWpService: PlatformApiWpService,
    protected override authService: MareAuthService,
    protected override tokenService: TokenService,
    protected override injector: Injector
  ) {
    super(authService, tokenService, injector);
  }

  retrieveAllProducts(body: ProductsRequestParams): Promise<any> {
    return new Promise((resolve, reject) => {
      // if (this.allProducts) {
      //   console.log('recuperati i prodotti dal service')
      //   resolve(this.allProducts);
      //   return;
      // }
      this.platformApiWpService.postRequest('/msc/v1/searchProducts', body).then((sub: any) => {
        sub.pipe(
          // map((res: any) => res.payload),
          catchError((err: any) => {
            reject(err)
            return err
          })
        ).subscribe((res: any) => {
          if (res.status === 'ok') {
            this.allProducts = res.payload.products;
          if(body.getVariations != undefined && body.getVariations != null) {
            this.hasVariations = body.getVariations
          }
          this.allOmniaInterestsProducts = res.payload.omnia_interest;
          this.allPurchasedProducts = res.payload.purchased;
          this.allPurchasedProducts$.next(this.allPurchasedProducts);
            resolve(res.payload.products);
          } else {
            reject(res)
          }
        })
      }, (err: any) => {
        reject(err)
      })
    })
  }



  getProducts(params?: ProductsRequestParams, force?: boolean): Promise<any> {
    console.log(this.allProducts);
    return new Promise((resolve, reject) => {
      if (this.allProducts && !force) {
        // if (params && params.skus) {
         
        //   let skus = params.skus.split(',');
         
        //   let filtered_product = this.allProducts.filter((product) => {
        //       return skus.includes(product.sku);
        //   });
        //   console.log('______ recupero prodotti filtrati dal service ____________')
        //   resolve(filtered_product);
        //   return;
        // }
        // console.log('______ recupero prodotti dal service ____________')
        resolve(this.allProducts);
      } else {
        if (!params) {
          params = {}
        }
        this.retrieveAllProducts(params).then((res: any) => {
          console.log('______ recupero prodotti da remoto ____________',params)
          resolve(res);
        }).catch((err: any) => {
          reject(err);
        })
      }
    })
  }

    /**
   * Retrieves a product by its SKU.
   * 
   * provide a single sku or a comma separated list of skus
   *
   * @param {string} sku - The SKU of the product to retrieve.
   * @return {Promise<any>} A promise that resolves with the product object if found, or rejects with an error message if not found.
   */
  getProductBySku(sku: string | string[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.allProducts) {
        if(Array.isArray(sku)) {
          let filtered_product = this.allProducts.filter((product) => {
              return sku.includes(product.sku);
          });
          resolve(filtered_product);
          return;
        }
        else if (typeof sku === 'string' && sku.indexOf(',') > -1) {
          let skus = sku.split(',');
          let filtered_product = this.allProducts.filter((product) => {
              return skus.includes(product.sku);
          });
          resolve(filtered_product);
          return;
        } else {
          let product = this.allProducts.find((product: any) => product.sku === sku);
          if (product) {
            resolve(product);
            return;
          }
        }
        
      }
      this.getProducts().then((res: any) => {
        let product = res.find((product: any) => product.sku === sku);
        if (product) {
          resolve(product);
        } else {
          console.error('Product not found. Please check if sku "'+sku+'" exist or is incorrectly written');
          reject('Product not found');
        }
      }).catch((err: any) => {
        reject(err);
      })
    })
  }

  getProductById(ids: number | number[]): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.allProducts) {
        if(Array.isArray(ids)) {
          let filtered_product = this.allProducts.filter((product) => {
              return ids.includes(product.id);
          });
          resolve(filtered_product);
          return;
        } else {
          let product = this.allProducts.find((product: any) => product.id === ids);
          if (product) {
            resolve(product);
            return;
          }
        }
      }
      this.getProducts().then((res: any) => {
        if (Array.isArray(ids)) {
          let filtered_product = res.filter((product:any) => {
              return ids.includes(product.id);
          });
          if(filtered_product)
            resolve(filtered_product);
          else
            reject('Product not found');
          return;
        } else {
          let product = res.find((product: any) => product.id === ids);
        if (product) {
          resolve(product);
        } else {
          console.error('Product not found. Please check if sku "'+ids+'" exist or is incorrectly written');
          reject('Product not found');
        }
        }
        
      }).catch((err: any) => {
        reject(err);
      })
    })
  }

  getProductsParams(body: ProductsRequestParams, preventError:boolean = false , preventLoader: boolean = false, force?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.allProducts && !force) {
        console.log('recuperati i prodotti dal service')
        if(body.ids || body.skus || body.cat || body.tags) {
          let filtered_product = this.filterProductByBodyParams(this.allProducts, body);
          resolve(filtered_product);
          return;
        } 
      }
      this.platformApiWpService.postRequest('/msc/v1/searchProducts', body, preventError, preventLoader).then((sub: any) => {
        sub.pipe(
          catchError((err: any) => {
            reject(err)
            return err
          }),
         
        ).subscribe((res: any) => {
          if (res && res.status === 'ok') {
              resolve(res.payload.products);
          } else {
            reject(res);
          }
        })
      }, (err: any) => {
        reject(err)
      })
    })
  }

  filterProductByBodyParams(array: any, body: ProductsRequestParams) {

    return array.filter((product:any) => {
      // Verifica per "skus", convertendo la lista di `body.skus` in un array se presente
      if (body.ids) {
        const idsArray = body.ids.split(',').map(idx => idx.trim());
        if (!idsArray.includes(product.id.toString())) return false;
      }
      if (body.skus) {
        const skusArray = body.skus.split(',').map(sku => sku.trim());
        if (!skusArray.includes(product.sku)) return false;
      }
      // Verifica per "cat", convertendo la lista di `body.cat` in un array se presente
      if (body.cat) {
        const catArray = body.cat.split(',').map(cat => cat.trim());
        if (!catArray.some(cat => product.categories.includes(cat))) return false;
      }
  
      // Verifica per "tags", convertendo la lista di `body.tags` in un array se presente
      if (body.tags) {
        const tagsArray = body.tags.split(',').map(tag => tag.trim());
        if (!tagsArray.some(tag => product.tags.includes(tag))) return false;
      }
  
      return true;
    });
  }

  findPendingRequestes(preventLoader?: boolean): Observable<any> {
    if (!preventLoader) {
      preventLoader = false;
    }
    return new Observable<any[]>(subscriber => {
      const servicepath = "msc/v1/findRequestes";

      const params = {
        status: 'started_or_waiting',
        isCount: false
      };
      // this.apiService.postRequest(servicepath, params, false, preventLoader).subscribe((response: any) => {
      this.platformApiWpService.postRequest(servicepath, params, false, preventLoader)
        .then((sub: any) => {
          sub.subscribe((response: any) => {
            console.log(response);
            
            if (response.status === 'ok' && response.payload) {
              subscriber.next(response.payload);
            } else {
              subscriber.error(response);
            }
          });
        })

    });
  }

  findPendingRequestesPromise(preventLoader?: boolean): Promise<any> {
    return new Promise((resolve, reject) => {
      this.findPendingRequestes(preventLoader).pipe(
        catchError((err: any) => {
          reject(err);
          return err;
        })
      ).subscribe((response: any) => {
        resolve(response);
      })
    })
  }



  checkProductStatus(product: any, pendingRequests: any): Promise<any> {
    return new Promise((resolve, reject) => {
      // if(!pendingRequests) {
      //   resolve();
      //   return;
      // }
      product.status = product.is_purchased ? 'is_purchased' : 'toActivate';
      pendingRequests.find((el:any)=>{
        if(el.id === product.id) {
          product.status = 'is_purchased';
        }
      })
      
      if (!pendingRequests) {
        product.status = 'toActivate';
        resolve(product);
         return;
      }
       
      pendingRequests.forEach((element: any) => {
        let sku!: string;
        /* proviamo a vedere prima se si tratta di prodotti omnia; nel caso dobbiamo ciclare in un oggetto specifico : element.document_application_options  */
        if (element.document_application_type === 'omnia') {
          let skus: any[] = [];
          if (element.document_application_options) {
            for (const key in element.document_application_options) {
              if (Object.prototype.hasOwnProperty.call(element.document_application_options, key)) {
                const el = element.document_application_options[key];
                if (el) {
                  skus.push(key);
                }
              }
            }
          }
          if (skus.length > 0) {
            skus.forEach((sku: string) => {
              let product = this.allProducts.find((product: any) => product.sku === sku);
              if (product) {
                this._calcProductStatus(product, element);
              }
            });
          }
  
        } else {
          sku = element.document_application_type;
          this._calcProductStatus(product, element);
        }
        /* qui siamo nel caso di prodotto NON omnia uindi trattato singolarmente */
        // if (sku) {
        //   let product = this.allProducts.find((product: any) => product.sku === sku);
        //   if (product) {
  
        //     this._calcProductStatus(product, element);
        //   }
        // }
      });

      resolve(product);
    })
  }


  checkAllProductStatus(product: any):void {

    this.allProducts.forEach((product: any) => {
      product.status = product.is_purchased ? 'is_purchased' : 'toActivate';
      this.pendingRequests.find((el:any)=>{
        if(el.id === product.id) {
          product.status = 'is_purchased';
        }
      })
      // this.checkisPurchased(product)
    });

    if (this.oldPendingRequests && this.oldPendingRequests.length > 0) {
      let completed: any = null;
      if (!this.pendingRequests || this.pendingRequests.length === 0) {
        completed = this.oldPendingRequests;
      } else {
        completed = this.oldPendingRequests.filter((element: any) => {
          return null == this.pendingRequests.find((element2: any) => {
            return element2.id === element.id;
          }
          );
        });
      }
      console.log('completed', completed);
      
      if (completed && completed.length > 0) {
        // TODO aggiornare i prodotti acquistati
        // console.log('completed', completed);
        return;
      }
    }

    /* controllo se ci sono prodotti in attesa di attivazione */
    if (!this.pendingRequests)
      return;
    this.pendingRequests.forEach((element: any) => {
      let sku!: string;
      /* proviamo a vedere prima se si tratta di prodotti omnia; nel caso dobbiamo ciclare in un oggetto specifico : element.document_application_options  */
      if (element.document_application_type === 'omnia') {
        let skus: any[] = [];
        if (element.document_application_options) {
          for (const key in element.document_application_options) {
            if (Object.prototype.hasOwnProperty.call(element.document_application_options, key)) {
              const el = element.document_application_options[key];
              if (el) {
                skus.push(key);
              }
            }
          }
        }
        if (skus.length > 0) {
          skus.forEach((sku: string) => {
            let product = this.allProducts.find((product: any) => product.sku === sku);
            if (product) {
              this._calcProductStatus(product, element);
            }
          });
        }

      } else {
        sku = element.document_application_type;
      }
      /* qui siamo nel caso di prodotto NON omnia uindi trattato singolarmente */
      if (sku) {
        let product = this.allProducts.find((product: any) => product.sku === sku);
        if (product) {

          this._calcProductStatus(product, element);
        }
      }
    });
  }

  _calcProductStatus(product: any, element: any) {
    if (product) {
      if (!element.completed_state || element.completed_state == '0') {
        /* è in corso un processo di firma/attivazione*/
        product.status = 'started';
        if (element.envelop_id) {
          product.envelop_id = element.envelop_id;
        }
        product.embedded = element.embedded && element.embedded == '1' ? true : false;
      } else if (element.completed_state && element.completed_state == '1') {
        /* è in corso un processo di firma/attivazione spettante al rappresentante legale */
        product.status = 'waiting';
      }
    }
  }

  retrieveLink(envelop_id: string) {

    return new Observable<{ envelop_id: string, redirect_url: string }>(subscriber => {
      if (!envelop_id)
        subscriber.error("envelop_id is required");

      const servicepath = "msc/v1/retrieveLink";


      this.platformApiWpService.postRequest(servicepath, { envelop_id: envelop_id })
        .then((sub: any) => {
          sub.subscribe((response: any) => {
            if (response.status === 'ok' && response.payload) {
              // console.log(response.payload);
              subscriber.next(response.payload);

            } else {
              subscriber.error(response);
            }
            //subscriber.next(response.payload);
          });
        })

    });
  }

  

}
